module.exports = "/_next/static/images/252e26063325b49b621c5866a0477a2d-Nubank_HickDuarte_58741_xs.jpg";